import { IDeviceDetailsDto, IDeviceTableViewDto } from '../Interfaces/IDeviceDtos';
import IPageResultDto from '../Interfaces/IPageResultDto';
import IResponseBaseDto from '../Interfaces/IResponseBaseDto';
import IResponseBaseTDto from '../Interfaces/IResponseBaseTDto';
import ISearchBaseDto from '../Interfaces/ISearchBaseDto';
import { apiClient } from '../Auth/apiClient';

// const Devices=[{
//   id: "string",
//   name: "string",
//   locationId: "string",
//   locationName: "Lokalizacja",
//   chainId: "string",
//   chainName: "string",
//   MacAddress:"string"},
//   {
//   id: "string2",
//   name: "string2",
//   locationId: "string2",
//   locationName: "Lokalizacja2",
//   chainId: "string2",
//   chainName: "string2",
//   MacAddress:"string"},
// ]

const DeviceServiceAPI = {
	GetPage: async (data: ISearchBaseDto): Promise<IResponseBaseTDto<IPageResultDto<IDeviceTableViewDto>>> => {
		const response = await apiClient.post('devices', data);
		return response.data;
		//  return{
		//    data:{
		//     items: Devices,
		//      currentPage: 1,
		//      itemsPerPage: 11,
		//      totalPages: 1,
		//      totalItemsCount: 11,
		//    },
		//    success: true,
		//    errors: [],
		//  };
	},
	GetOne: async (id: string): Promise<IResponseBaseTDto<IDeviceDetailsDto>> => {
		const response = await apiClient.post('device', { deviceId: id });
		return response.data;
		//  return {
		//   data:Devices.filter(d=>d.id===id)[0],
		//    success: true,
		//    errors: [],
		//  };
	},
	Delete: async (id: string): Promise<IResponseBaseDto> => {
		const response = await apiClient.delete(`devices/${id}`);
		return response.data;
	},
	Update: async (data: IDeviceDetailsDto): Promise<IResponseBaseDto> => {
		const response = await apiClient.put(`devices/${data.id}`, data);
		return response.data;
	},
	Add: async (data: IDeviceDetailsDto): Promise<IResponseBaseDto> => {
		const response = await apiClient.post('devices', data);
		return response.data;
	},
	SynchronizeCampaign: async (deviceId: string): Promise<IResponseBaseDto> => {
		const response = await apiClient.get(`device/synchronizeCampaign?deviceId=${deviceId}`);
		return response.data;
	},
};

export default DeviceServiceAPI;
